<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

Chart.defaults.scale.gridLines.display = false;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "titulo"],
  data() {
    return {
      options: {
        title: {
          display: true,
          text: this.titulo
        },
        responsive: true,
        scales: {
          xAxe: { gridLines: { display: false } },
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: true
        },
        onClick: function clickHandler(evt) {
          var firstPoint = this.getElementAtEvent(evt)[0];

          if (firstPoint) {
            var label = this.data.labels[firstPoint._index];
            var value = this.data.datasets[firstPoint._datasetIndex].data[
              firstPoint._index
            ];

            evt.stopPropagation()

            document.dispatchEvent(
              new CustomEvent("openDay", {
                detail: label
              })
            );
          }
        }
      }
    };
  },
  mounted() {
    try {
      
      this.renderChart(this.chartData, this.options);
    } catch (error) {
    }
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/charts/Bar.vue